<template>
  <div class="animated fadeIn">

    <div class="col-sm-12 col-md-12">
      <div id="dados-formulario-tab" class="card">
        <div class="card-body">
          <div id="titulo">
					  <div class="row">
						  <div class="col-sm-12 col-md-12">
							  <h4>Editar Motorista</h4>
							</div>
						</div>
					  <div class="row">
						  <div class="col-sm-12 col-md-12 pull-right">
							  <input id="botaoSalvar" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
                <router-link id="btnNovoCliente" class="btn btn-warning" to="/motoristas">
									<span class="glyphicon glyphicon-back"></span> Fechar
								</router-link>
                <span id="imprimirLinks"> </span>
						  </div>
					  </div>
				  </div>


          <div class="row">
            <div class="col-sm-12 col-md-12">
        	    <div class="tabbable">
        				<!-- Only required for left/right tabs -->
                <ul class="nav nav-tabs">
                  <li class="nav-item active"><a href="#tabGeral" data-toggle="tab" class="nav-link active">Geral</a></li>
                  <li class="nav-item"><a href="#tabJornada" data-toggle="tab" class="nav-link">Jornada</a></li>
                  
                </ul>
        				<div class="tab-content">
        					<div class="tab-pane active" id="tabGeral">
        						<div class="dados_form">
        							<div class="col-sm-12 col-md-12">
        								<input type="hidden" v-model="model.id" />
        								<div class="row">
        									<div class="form-group col-sm-2 col-md-2">
        										<label>Ativo:</label><br>
        										<select class="pula form-control custom" v-model="model.ativo">
                              <option value="false" label="Não">Não</option>
          										<option value="true" label="Sim">Sim</option>
        										</select>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label>Data Nascimento:</label><br>
        										<input-data-picker class="pula data form-control" v-model="model.dataNascimento" />
        									</div>
                          <div class="form-group col-sm-3 col-md-4">
                            <label>Tipo Jornada:</label><br>
                            <select class="pula form-control custom" v-model="model.tipoJornadaAjudante">
                              <option value="T" label="Total">Total</option>
                            </select>
                          </div>
        								</div>

                        <template v-if="$auth.check('P110')">
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12">
                              <label>Cliente:</label><br>
                              <input type="hidden" id="clienteId" v-model="model.clienteId" />
                              <buscar-cliente  v-validate="'required'" id="clienteNome" name="clienteNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :required="true" :errors="errors.has('clienteNome')" v-model="model.clienteNomeFantasia" :on-select="setarCliente" :on-blur="verificarCliente"/>
                            </div>
                          </div>
                        
                        </template>
                        </div>
        								<div class="row">
        									<div class="form-group col-sm-12 col-md-12">
        										<label class="control-label">Nome:</label><br>
        										<input class="pula form-control" v-model="model.nome"></input>
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-2 col-md-2">
        										<label id="label-documento" class="control-label">Documento:</label><br>
        										<input-cpf class="pula form-control" v-model="model.documento"/>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">RG:</label><br>
        										<input class="pula form-control" v-model="model.rg" />
        									</div>
        								</div>

        								<div class="row">
        									<div class="form-group col-sm-10 col-md-10">
        										<label class="control-label">Endereço:</label><br>
        										<input class="pula form-control" v-model="model.endereco" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Número:</label><br>
        										<input class="pula form-control" v-model="model.numero" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-8 col-md-8">
        										<label class="control-label">Complemento:</label><br>
        										<input class="pula form-control" v-model="model.complemento" />
        									</div>
        									<div class="form-group col-sm-4 col-md-4">
        										<label class="control-label">Bairro:</label><br>
        										<input class="pula form-control" v-model="model.bairro" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-6 col-md-6">
        										<label class="control-label">Cidade:</label><br>
      											<input type="hidden" id="cidadeId" v-model="model.cidadeId" />
                            <buscar-cidade type="search" id="cidadeNome" v-model="model.cidadeNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarCidade" :on-blur="verificarCidade"  />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">CEP:</label><br>
        										<input-cep id="cidadeCep" class="pula form-control" v-model="model.cep" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Estado:</label><br>
        										<input id="cidadeEstado" class="pula form-control" v-model="model.estado" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Telefone:</label><br>
        										<input-telefone class="pula form-control" v-model="model.telefone" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Celular:</label><br>
        										<input-telefone-celular class="pula form-control" v-model="model.celular" />
        									</div>
        									<div class="form-group col-sm-1 col-md-1">
        										<label class="control-label">WhatsApp:</label><br>
        										<input id="whatsapp" class="pula" name="whatsapp" type="checkbox" v-model="model.whatsapp" />
        										<a id="abrirWhatsApp" href="#" class="btn"><img src="/static/images/whatsapp.png"></a>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Operadora:</label><br>
        										<a href="#" class="btn" id="consultaOperadora" v-on:click="buscarOperadora(model.celular)"><img src="/static/images/buscar.png"></a>
                            <img id="logoCelularOperadora" v-bind:src="'/static/images/'+model.celularOperadora+'.png'">
                            <input type="hidden" class="pula form-control" v-model="model.celularOperadora" />
        									</div>
        									<div class="form-group col-sm-3 col-md-3">
        										<label class="control-label">E-mail:</label><br>
        										<input class="pula form-control" v-model="model.email" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-4 col-md-4">
        										<label>CNH:</label><br>
        										<input class="pula form-control" v-model="model.cnh" />
        									</div>
                          <div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Primeira CNH:</label><br>
        										<input class="pula form-control" v-model="model.primeiraCnh" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Tipo CNH:</label><br>
        										<input class="pula form-control" v-model="model.tipoCnh" />
        									</div>
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Vencimento CNH:</label><br>
                            <input class="pula form-control" v-model="model.vencimentoCnh" />
                          </div>
        								</div>
                        <div class="row">
                          <div class="form-group col-sm-3 col-md-4">
                            <label>Cód. Empresa:</label><br>
                            <input class="pula form-control" v-model="model.codigoEmpresa" />
                          </div>
                          <div class="form-group col-sm-3 col-md-4">
                            <label>Cód. Rastreador:</label><br>
                            <input class="pula form-control" v-model="model.codigoRastreador" />
                          </div>

                          <div class="form-group col-sm-3 col-md-4">
                            <label>Login:</label><br>
                            <input class="pula form-control" v-model="model.login" />
                          </div>
                          <div class="form-group col-sm-3 col-md-4">
                            <label>Senha:</label><br>
                            <input class="pula form-control" v-model="model.senha" />
                          </div>

                          <div class="form-group col-sm-3 col-md-4">
                            <label>Número Pis:</label><br>
                            <input class="pula form-control" v-model="model.numeroPis" />
                          </div>
                          <div class="form-group col-sm-3 col-md-4">
                            <label>Cargo:</label><br>
                            <input class="pula form-control" v-model="model.cargo" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-sm-2 col-md-2">
                            <label>Empresa CNPJ:</label><br>
                            <input-cnpj class="pula form-control" v-model="model.empresaCnpj" />
                          </div>
                          <div class="form-group col-sm-5 col-md-5">
                            <label>Empresa Nome:</label><br>
                            <input class="pula form-control" v-model="model.empresaNome" />
                          </div>
                          <div class="form-group col-sm-5 col-md-5">
                            <label>Empresa Endereço:</label><br>
                            <input class="pula form-control" v-model="model.empresaEndereco" />
                          </div>
                        </div>

        								<div class="row">
        									<div class="form-group col-sm-12 col-md-12">
        										<label>Observação:</label><br>
        										<textarea rows="3" class="pula form-control" v-model="model.observacao" />
        									</div>
        								</div>
        							</div>
        						</div>

                    <div class="tab-pane" id="tabJornada">
                      <div class="dados_form">
                        <div class="col-sm-12 col-md-12">
                          <input type="hidden" v-model="model.id" />
                          <div class="row">
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Horário da Jornada Controlado:</label><br>
                              <select class="pula form-control custom" v-model="model.jornadaHorarioControlado">
                                <option value="false" label="Não">Não</option>
                                <option value="true" label="Sim">Sim</option>
                              </select>
                            </div>
                            <div class="form-group col-sm-4 col-md-4">
                              <label>Tolerancia Inicio Fim de Jornada:</label><br>
                              <input-hora-picker v-model="model.inicioFimJornadaTolerancia" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-4 col-md-4">
                              <label>Macro Fora Horário Almoço:</label><br>
                              <select class="form-control" required="required" v-model="model.macroForaMargemHorarioAlmoco">
                                <option value="03">03 - Espera</option>
                                <option value="05">05 - Descanso Direcao</option>
                                <option value="34">34 - Diaria</option>
                              </select>
                            </div>
                            <div class="form-group col-sm-4 col-md-4">
                              <label>Tipo Controle Jornada:</label><br>
                              <select class="form-control" required="required" v-model="model.tipoControleJornada">
                                <option value="1">I-button</option>
                                <option value="2">Teclado virtual</option>
                              </select>
                            </div>
                            <div class="form-group col-sm-4 col-md-4">
                              <label>Código Motorista Cadastro Empresa:</label><br>
                              <input v-model="model.codigoCadastroEmpresa" class="form-control pula hora" />    
                            </div>

                          </div> 
                          <div class="row">
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Início Jornada Segunda a Quinta:</label><br>
                              <input-hora-picker-ss v-model="model.inicioJornadaSegundaQuinta" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Fim Jornada Segunda a Quinta:</label><br>
                              <input-hora-picker-ss v-model="model.fimJornadaSegundaQuinta" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Inicio:</label><br>
                              <input-hora-picker-ss v-model="model.margemInicioAlmocoSegundaQuinta" class="form-control pula hora" />
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Final:</label><br>
                              <input-hora-picker-ss v-model="model.margemFinalAlmocoSegundaQuinta" class="form-control pula hora" />
                            </div>

                            <div class="form-group col-sm-2 col-md-2">
                              <label>Duração Jornada:</label><br>
                              <input-hora-picker-ss v-model="model.jornadaDuracaoSegundaQuinta" class="form-control pula hora" />
                            </div>

                          </div>

                          <div class="row">
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Início Jornada Sexta:</label><br>
                              <input-hora-picker-ss v-model="model.inicioJornadaSexta" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Fim Jornada Sexta:</label><br>
                              <input-hora-picker-ss v-model="model.fimJornadaSexta" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Inicio:</label><br>
                              <input-hora-picker-ss v-model="model.margemInicioAlmocoSexta" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Final:</label><br>
                              <input-hora-picker-ss v-model="model.margemFinalAlmocoSexta" class="form-control pula hora" />    
                            </div>

                            <div class="form-group col-sm-2 col-md-2">
                              <label>Duração Jornada:</label><br>
                              <input-hora-picker-ss v-model="model.jornadaDuracaoSexta" class="form-control pula hora" />
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Início Jornada Sábado:</label><br>
                              <input-hora-picker-ss v-model="model.inicioJornadaSabado" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Final Jornada Sábado:</label><br>
                              <input-hora-picker-ss v-model="model.fimJornadaSabado" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Inicio:</label><br>
                              <input-hora-picker-ss v-model="model.margemInicioAlmocoSabado" class="form-control pula hora" />
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Final:</label><br>
                              <input-hora-picker-ss v-model="model.margemFinalAlmocoSabado" class="form-control pula hora" />
                            </div>

                            <div class="form-group col-sm-2 col-md-2">
                              <label>Duração Jornada:</label><br>
                              <input-hora-picker-ss v-model="model.jornadaDuracaoSabado" class="form-control pula hora" />
                            </div>
                            
                          </div>

                          <div class="row">
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Início Jornada Domingo:</label><br>
                              <input-hora-picker v-model="model.inicioJornadaDomingo" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-3 col-md-3">
                              <label>Final Jornada Domingo:</label><br>
                              <input-hora-picker-ss v-model="model.fimJornadaDomingo" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Inicio:</label><br>
                              <input-hora-picker-ss v-model="model.margemInicioAlmocoDomingo" class="form-control pula hora" />    
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label>Margem Almoço Final:</label><br>
                              <input-hora-picker-ss v-model="model.margemFinalAlmocoDomingo" class="form-control pula hora" />    
                            </div>

                            <div class="form-group col-sm-2 col-md-2">
                              <label>Duração Jornada:</label><br>
                              <input-hora-picker-ss v-model="model.jornadaDuracaoDomingo" class="form-control pula hora" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
        					</div>


                  
        				
        				</div>
        			</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import LineChart from '../LineChart.js'
import Blob from 'blobjs'
export default {
  components: {
    LineChart
  },
  data () {
    return {
      model: {
        id: '0',
        ativo: true,
        clienteId: '0',
        clienteNomeFantasia: '',
        motorista: true,
        tipoJornadaAjudante: 'T',
        nome: '',
        documento: '',
        rg: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidadeId: '0',
        cidadeNome: '',
        cep: '',
        estado: '',
        telefone: '',
        celular: '',
        celularOperadora: '',
        email: '',
        cnh: '',
        tipoCnh: '',
        primeiraCnh: '',
        vencimentoCnh: '',
        codigoEmpresa: '',
        codigoRastreador: '',
        login: '',
        senha: '',
        numeroPis: '',
        cargo: '',
        jornada: '',
        dataNascimento: '',
        dataCadastro: '',
        empresaCnpj: '',
        empresaNome: '',
        empresaEndereco: '',
        observacao: '',
        jornadaHorarioControlado: false,
        inicioJornadaSegundaQuinta: '00:00:00',
        margemInicioAlmocoSegundaQuinta: '00:00:00',
        margemFinalAlmocoSegundaQuinta: '00:00:00',

        fimJornadaSegundaQuinta: '00:00:00',
        inicioJornadaSexta: '00:00:00',
        margemInicioAlmocoSexta: '00:00:00',
        margemFinalAlmocoSexta: '00:00:00',

        fimJornadaSexta: '00:00:00',
        inicioJornadaSabado: '00:00:00',
        margemInicioAlmocoSabado: '00:00:00',
        margemFinalAlmocoSabado: '00:00:00',

        fimJornadaSabado: '00:00:00',
        inicioJornadaDomingo: '00:00:00',
        margemInicioAlmocoDomingo: '00:00:00',
        margemFinalAlmocoDomingo: '00:00:00',
        fimJornadaDomingo: '00:00:00',

        jornadaDuracaoSegundaQuinta: '00:00:00',
        jornadaDuracaoSexta: '00:00:00',
        jornadaDuracaoSabado: '00:00:00',
        jornadaDuracaoDomingo: '00:00:00',

        inicioFimJornadaTolerancia: '00:00:00',
        macroForaMargemHorarioAlmoco: '',
        tipoControleJornada: '',
        codigoCadastroEmpresa: ''
      },
      isentoInscricaoEstadual: false,
      isentoInscricaoMunicipal: false,
      conceitos: [],
      formasPagamentos: [],
      tabelasPrecos: [],
      vendedores: [],
      motoristaCreditoFinanceiro: [],
      historicoFinanceiro: [],
      historicoCheques: [],
      vendasProdutos: [],
      vendasServicos: [],
      interacoes: [],
      perfilClienteGraficoVendas: null,
      vendasPeriodo: '12',
      vendasPeriodoAgrupamento: 'S',
      vendasProdutosMaisVendidosPeriodo: '12',
      vendasProdutosMaisVendidosPeriodoAgrupamento: 'V',
      vendasPeriodoLabels: [],
      vendasPeriodoDados: [],
      vendasProdutosMaisVendidosPeriodoDados: [],
      exibirFinanceiro: 30,
      exibirFinanceiroCredito: 30,
      exibirFinanceiroCheques: 30,
      showModalProdutosRelacionados: false,
      selecionadosFinanceiros: [],
      selecionadosCreditos: [],
      selecionadosCheques: []
    }
  },
  created: function () {
    this.buscar()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token, 'connection': 'keep-alive'}
      }
      var url = '/api/motoristas/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        console.log(response.data.nomeFantasia)
        var dados = response.data
        self.model.id = dados.id
        if (dados.cliente !== null) {
          self.model.clienteId = dados.cliente.id
          self.model.clienteNomeFantasia = dados.cliente.nomeFantasia
        }
        self.model.ativo = dados.ativo
        self.model.tipoJornadaAjudante = dados.tipoJornadaAjudante
        self.model.nome = dados.nome
        self.model.documento = dados.documento
        self.model.rg = dados.rg
        self.model.endereco = dados.endereco
        self.model.numero = dados.numero
        self.model.complemento = dados.complemento
        self.model.bairro = dados.bairro
        if (dados.cidade !== null) {
          self.model.cidadeId = dados.cidade.id
          self.model.cidadeNome = dados.cidade.cidade
        }
        self.model.cep = dados.cep
        self.model.estado = dados.estado
        self.model.contato = dados.contato
        self.model.telefone = dados.telefone
        self.model.celular = dados.celular
        self.model.whatsapp = dados.whatsapp
        self.model.celularOperadora = dados.celularOperadora
        self.model.email = dados.email
        self.model.cnh = dados.cnh
        self.model.primeiraCnh = dados.primeiraCnh
        self.model.tipoCnh = dados.tipoCnh
        self.model.vencimentoCnh = dados.vencimentoCnh
        self.model.codigoEmpresa = dados.codigoEmpresa
        self.model.codigoRastreador = dados.codigoRastreador
        self.model.login = dados.login
        self.model.senha = dados.senha
        self.model.numeroPis = dados.numeroPis
        self.model.cargo = dados.cargo
        self.model.jornada = dados.jornada
        self.model.dataNascimento = dados.dataNascimento
        self.model.dataCadastro = dados.dataCadastro
        self.model.empresaCnpj = dados.empresaCnpj
        self.model.empresaNome = dados.empresaNome
        self.model.empresaEndereco = dados.empresaEndereco
        self.model.observacao = dados.observacao

        self.model.jornadaHorarioControlado = dados.jornadaHorarioControlado
        self.model.inicioJornadaSegundaQuinta = dados.inicioJornadaSegundaQuinta
        self.model.margemInicioAlmocoSegundaQuinta = dados.margemInicioAlmocoSegundaQuinta
        self.model.margemFinalAlmocoSegundaQuinta = dados.margemFinalAlmocoSegundaQuinta
        self.model.fimJornadaSegundaQuinta = dados.fimJornadaSegundaQuinta
        self.model.inicioJornadaSexta = dados.inicioJornadaSexta
        self.model.margemInicioAlmocoSexta = dados.margemInicioAlmocoSexta
        self.model.margemFinalAlmocoSexta = dados.margemFinalAlmocoSexta
        self.model.fimJornadaSexta = dados.fimJornadaSexta
        self.model.inicioJornadaSabado = dados.inicioJornadaSabado
        self.model.margemInicioAlmocoSabado = dados.margemInicioAlmocoSabado
        self.model.margemFinalAlmocoSabado = dados.margemFinalAlmocoSabado
        self.model.fimJornadaSabado = dados.fimJornadaSabado
        self.model.inicioJornadaDomingo = dados.inicioJornadaDomingo
        self.model.margemInicioAlmocoDomingo = dados.margemInicioAlmocoDomingo
        self.model.margemFinalAlmocoDomingo = dados.margemFinalAlmocoDomingo
        self.model.fimJornadaDomingo = dados.fimJornadaDomingo
        self.model.inicioFimJornadaTolerancia = dados.inicioFimJornadaTolerancia
        self.model.macroForaMargemHorarioAlmoco = dados.macroForaMargemHorarioAlmoco
        self.model.tipoControleJornada = dados.tipoControleJornada
        self.model.codigoCadastroEmpresa = dados.codigoCadastroEmpresa
        self.model.jornadaDuracaoSegundaQuinta = dados.jornadaDuracaoSegundaQuinta
        self.model.jornadaDuracaoSexta = dados.jornadaDuracaoSexta
        self.model.jornadaDuracaoSabado = dados.jornadaDuracaoSabado
        self.model.jornadaDuracaoDomingo = dados.jornadaDuracaoDomingo
      })
    },
    buscarConceitos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarConceitos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.conceitos = dados
      })
    },
    buscarFormasPagamentos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarFormasPagamentos?busca=&tipo='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.formasPagamentos = dados
      })
    },
    buscarTabelasPrecos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarProdutosTabelasPrecos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.tabelasPrecos = dados
      })
    },
    buscarVendedores: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVendedores?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.vendedores = dados
      })
    },
    buscarEnderecos: function () {
      var self = this
      if (self.model.enderecos.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/buscarClientesEnderecos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.model.enderecos = dados
        })
      }
    },
    buscarContatos: function () {
      var self = this
      if (self.model.contatos.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/buscarClientesContatos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.model.contatos = dados
        })
      }
    },
    buscarHistoricoCredito: function () {
      var self = this
      if (self.motoristaCreditoFinanceiro.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/buscarClientesCreditos?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCredito
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.motoristaCreditoFinanceiro = dados
        })
      }
    },
    selecionarCreditoItem: function (item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCreditos.includes(item)) {
          let p = this.selecionadosCreditos.indexOf(item)
          this.selecionadosCreditos.splice(p, 1)
        } else {
          this.selecionadosCreditos.push(item)
        }
      } else {
        this.selecionadosCreditos = []
        this.selecionadosCreditos.push(item)
      }
    },
    selecionadoCredito: function (item) {
      return this.selecionadosCreditos.includes(item)
    },
    buscarHistoricoFinanceiro: function () {
      var self = this
      // if (self.historicoFinanceiro.length === 0) {
      let config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      let url = '/api/motoristaHistoricoFinanceiro?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiro
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.historicoFinanceiro = dados
      })
    },
    selecionarFinanceiroItem: function (item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosFinanceiros.includes(item)) {
          let p = this.selecionadosFinanceiros.indexOf(item)
          this.selecionadosFinanceiros.splice(p, 1)
        } else {
          this.selecionadosFinanceiros.push(item)
        }
      } else {
        this.selecionadosFinanceiros = []
        this.selecionadosFinanceiros.push(item)
      }
    },
    selecionadoFinanceiro: function (item) {
      return this.selecionadosFinanceiros.includes(item)
    },
    buscarHistoricoCheque: function () {
      var self = this
      let config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      let url = '/api/motoristaHistoricoCheque?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCheques
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.historicoCheques = dados
      })
    },
    selecionarChequeItem: function (item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCheques.includes(item)) {
          let p = this.selecionadosCheques.indexOf(item)
          this.selecionadosCheques.splice(p, 1)
        } else {
          this.selecionadosCheques.push(item)
        }
      } else {
        this.selecionadosCheques = []
        this.selecionadosCheques.push(item)
      }
    },
    selecionadoCheque: function (item) {
      return this.selecionadosCheques.includes(item)
    },
    valorTotalPagarFinanceiro: function (financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor
          }
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor
          }
          return valorTotalPagar
        }, 0)
      }
    },
    valorTotalPagoFinanceiro: function (financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago
          }
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago
          }
          return valorTotalPagar
        }, 0)
      }
    },
    valorTotalCredito: function (financeiroMovimento) {
      if (this.selecionadosCreditos.length > 1) {
        return this.selecionadosCreditos.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      }
    },
    valorTotalCheque: function (financeiroMovimento) {
      if (this.selecionadosCheques.length > 1) {
        return this.selecionadosCheques.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      }
    },
    buscarHistoricoVendas: function () {
      var self = this
      if (self.vendasProdutos.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/motoristasHistoricoVendasProdutos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.vendasProdutos = dados
        })
      }
      if (self.vendasServicos.length === 0) {
        url = '/api/motoristasHistoricoVendasServicos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.vendasServicos = dados
        })
      }
    },
    buscarHistoricoInteracoes: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/motoristasHistoricoInteracoes/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.interacoes = dados
      })
    },
    buscarOperadora: function (numero) {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/consutarOperadora?celular=' + numero
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.model.celularOperadora = response.data
      })
    },
    setIsentoInscricaoEstadual: function () {
      if (this.isentoInscricaoEstadual === false) {
        this.model.inscricaoEstadual = 'ISENTO'
      } else {
        this.model.inscricaoEstadual = ''
      }
    },
    setIsentoInscricaoMunicipal: function () {
      if (this.isentoInscricaoMunicipal === false) {
        this.model.inscricaoMunicipal = 'ISENTO'
      } else {
        this.model.inscricaoMunicipal = ''
      }
    },
    setarCliente: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarCliente: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarCidade: function (cidade) {
      this.model.cidadeId = cidade.id
      this.model.cidadeNome = cidade.cidade
      this.model.cep = cidade.cep
      this.model.estado = cidade.estado
      $(this.$el).find('#cidadeNome').val(cidade.cidade)
      $(this.$el).find('#cidadeCep').val(cidade.cep)
      $(this.$el).find('#cidadeEstado').val(cidade.estado)
    },
    verificarCidade: function () {
      if ($(this.$el).find('#cidadeId').val() === '0') {
        this.model.cidadeId = 0
        this.model.cidadeNome = ''
        this.model.cep = ''
        this.model.estado = ''
        $(this.$el).find('#cidadeId').val(0)
        $(this.$el).find('#cidadeNome').val('')
        $(this.$el).find('#cidadeCep').val('')
        $(this.$el).find('#cidadeEstado').val('')
      }
      if ($(this.$el).find('#cidadeNome').val() === '') {
        this.model.cidadeId = 0
        this.model.cidadeNome = ''
        this.model.cep = ''
        this.model.estado = ''
        $(this.$el).find('#cidadeId').val(0)
        $(this.$el).find('#cidadeNome').val('')
        $(this.$el).find('#cidadeCep').val('')
        $(this.$el).find('#cidadeEstado').val('')
      }
    },
    setarCidadeEndereco: function (cidade, i) {
      console.log('Item: ' + i)
      this.model.enderecos[i].cidadeId = cidade.id
      this.model.enderecos[i].cidadeNome = cidade.cidade
      this.model.enderecos[i].cep = cidade.cep
      this.model.enderecos[i].estado = cidade.estado
      $(this.$el).find('#enderecosCidadeNome_' + i).val(cidade.cidade)
      $(this.$el).find('#enderecosCidadeCep_' + i).val(cidade.cep)
      $(this.$el).find('#enderecosCidadeEstado_' + i).val(cidade.estado)
    },
    adicionarEndereco: function () {
      var self = this
      self.model.enderecos.push({
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        pontoReferencia: '',
        cidadeId: '0',
        cidade: '',
        cep: '',
        tipoEnderecoId: '0'
      })
    },
    removerEndereco: function (i) {
      var self = this
      self.model.enderecos.splice(i, 1)
    },
    adicionarContato: function () {
      var self = this
      self.model.contatos.push({
        nome: '',
        telefone: '',
        email: ''
      })
    },
    removerContato: function (i) {
      var self = this
      self.model.contatos.splice(i, 1)
    },
    buscarPerfilCliente: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/vendasPeriodo?periodo=' + this.vendasPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento + '&motoristaId=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        let periodos = []
        for (let i = 0; i < response.data.length; i++) {
          periodos.push(response.data[i].periodo + '/' + response.data[i].ano)
        }
        let valores = []
        for (let i = 0; i < response.data.length; i++) {
          valores.push(response.data[i].valorTotalVenda)
        }
        self.perfilClienteGraficoVendas = {
          labels: periodos,
          datasets: [
            {
              label: 'Vendas',
              backgroundColor: '#79c447',
              data: valores
            }
          ]
        }
      })
      url = '/api/dashboard/vendasProdutosMaisVendidosPeriodo?periodo=' + this.vendasProdutosMaisVendidosPeriodo + '&agrupamento=' + this.vendasProdutosMaisVendidosPeriodoAgrupamento + '&motoristaId=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.vendasProdutosMaisVendidosPeriodoDados = response.data
      })
    },
    imprimirVendaProduto: function (vendaProdutoId) {
      // Imprimir
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/vendas/imprimirVenda?id=' + vendaProdutoId + '&exibirCliente=1&exibirMarca=1&exibirPreco=1&exibirPrecoPadrao=0&exibirPromissoria=0'
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
      })
    },
    visualizarFinanceiro: function (movimento) {
      // this.$router.replace('/financeiroMovimentoVisualizar/' + movimento.id)
      // let routeData = this.$router.resolve({name: 'FinanceiroMovimentoVisualizar', query: {data: movimento.id}})
      window.open('/financeiroMovimentoVisualizar/' + movimento.id, '_blank')
    },
    salvar: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.model))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          var url = '/api/motoristas/salvar'
          axios.post(url, JSON.stringify(self.model), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Motorista gravado com sucesso.', 'Atenção')
              self.$router.replace('/motoristas')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/motoristas/MotoristasEditar.vue